'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('oddQuestionnaireTemplateModule')
    .factory('oddQuestionnaireTemplateService', ['$http', '$q', function ($http) {
        var baseUrl = environment.apiUrl + '/Pilot/api/ODD/BusinessUnit',
            oddUrl = environment.apiUrl + '/Pilot/api/ODD';

        return {

            // ==== Questionnaire Template ====

            // Get Questionnaires
            getQuestionnaires: function (businessUnitId) {
                return $http
                    .get(baseUrl + '/' + businessUnitId + '/Questionnaire')
                    .then(function (response) { return response.data; })
            },

            // Get Questionnaire
            getQuestionnaire: function (businessUnitId, questionnaireId) {
                return $http
                    .get(baseUrl + '/' + businessUnitId + '/Questionnaire/' + questionnaireId)
                    .then(function (response) {
                        return response.data;
                    })
            },

            // Create Questionnaire
            createQuestionnaire: function (businessUnitId, questionnaire) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Questionnaire';

                return $http
                    .post(reqUrl, questionnaire)
                    .then(function (response) { return response.data; })
            },

            // Update Questionnaire
            updateQuestionnaire: function (businessUnitId, questionnaire) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Questionnaire/' + questionnaire.ODDQuestionnaireID;

                return $http
                    .put(reqUrl, questionnaire)
                    .then(function (response) { return response.data; })
            },

            duplicateQuestionnaire: function (businessUnitId, questionnaireId, titleEn) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Questionnaire/' + questionnaireId + '/Duplicate';

                return $http
                        .post(reqUrl, { TitleEN: titleEn })
                        .then(function (response) { return response.data; })
            },

            // Delete Questionnaire
            deleteQuestionnaire: function (businessUnitId, questionnaireId) {
                return $http
                    .delete(baseUrl + '/' + businessUnitId + '/Questionnaire/' + questionnaireId)
                    .then(function (response) { return response.data; })
            },

            // Share Questionnaire
            shareQuestionnaire: function (businessUnitId, questionnaireId) {
                return $http
                    .post(baseUrl + '/' + businessUnitId + '/Questionnaire/' + questionnaireId + '/Share')
                    .then(function (response) { return response.data; })
            },

            // Unshare Questionnaire
            unshareQuestionnaire: function (businessUnitId, questionnaireId) {
                return $http
                    .post(baseUrl + '/' + businessUnitId + '/Questionnaire/' + questionnaireId + '/Unshare')
                    .then(function (response) { return response.data; })
            },

            // ==== Section ====

            // Create Section
            createSection: function (businessUnitId, questionnaireId, section) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Questionnaire/' + questionnaireId + '/Section';

                return $http
                    .post(reqUrl, section)
                    .then(function (response) { return response.data; })
            },

            // Update Section
            updateSection: function (businessUnitId, questionnaireId, section) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Questionnaire/' + questionnaireId + '/Section/' + section.ODDSectionID;

                return $http
                    .put(reqUrl, section)
                    .then(function (response) { return response.data; })
            },

            // Sort Section
            orderSections: function (businessUnitId, questionnaireId, sections) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Questionnaire/' + questionnaireId + '/Section/Order';

                return $http
                    .put(reqUrl, sections)
                    .then(function (response) { return response.data; })
            },

            // Get Section
            getSection: function (businessUnitId, questionnaireId, sectionId) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Questionnaire/' + questionnaireId + '/Section/' + sectionId;

                return $http
                    .get(reqUrl)
                    .then(function (response) { return response.data; }).then(function(section) {
                        // populate conditional question and choices.
                        section.ODDComponents.forEach(function(question) {
                            if (question.ConditionalODDQuestionID && !question.ConditionalODDQuestion) {
                                question.ConditionalODDQuestion = _.find(section.ODDComponents, { ODDQuestionID: question.ConditionalODDQuestionID });
                            }

                            if (question.ConditionalODDQuestion && question.ConditionalODDQuestionChoiceID && !question.ConditionalODDQuestionChoice) {
                                question.ConditionalODDQuestionChoice = _.find(question.ConditionalODDQuestion.ODDQuestionChoices, { ODDQuestionChoiceID: question.ConditionalODDQuestionChoiceID });
                            }
                        });
                        return section;
                    })
            },

            // Delete Section
            deleteSection: function (businessUnitId, questionnaireId, sectionId) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Questionnaire/' + questionnaireId + '/Section/' + sectionId;

                return $http
                    .delete(reqUrl)
                    .then(function (response) { return response.data; })
            },

            // ==== StaticText ====

            // Get StaticText
            getStaticText: function (businessUnitId, questionnaireId, sectionId, staticTextId) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Questionnaire/' + questionnaireId + '/Section/' + sectionId + '/StaticText/' + staticTextId;
                return $http
                    .get(reqUrl)
                    .then(function (response) { return response.data; })
            },
            // Create StaticText
            createStaticText: function (businessUnitId, questionnaireId, sectionId, staticText) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Questionnaire/' + questionnaireId + '/Section/' + sectionId + '/StaticText';
                return $http
                    .post(reqUrl, staticText)
                    .then(function (response) { return response.data; })
            },

            // Update StaticText
            updateStaticText: function (businessUnitId, questionnaireId, sectionId, staticText) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Questionnaire/' + questionnaireId + '/Section/' + sectionId + '/StaticText/' + staticText.ODDStaticTextID;
                return $http
                    .put(reqUrl, staticText)
                    .then(function (response) { return response.data; })
            },
            // Delete StaticText
            deleteStaticText: function (businessUnitId, questionnaireId, sectionId, staticTextId) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Questionnaire/' + questionnaireId + '/Section/' + sectionId + '/StaticText/' + staticTextId;
                return $http
                    .delete(reqUrl)
                    .then(function (response) { return response.data; })
            },

            // ==== Question ====

            // Get Question
            getQuestion: function (businessUnitId, questionnaireId, sectionId, questionId) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Questionnaire/' + questionnaireId + '/Section/' + sectionId + '/Question/' + questionId;

                return $http
                    .get(reqUrl)
                    .then(function (response) { return response.data; })
            },

            // Get Conditionable Questions
            getConditionableQuestions: function (businessUnitId, questionnaireId, sectionId, questionId) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Questionnaire/' + questionnaireId + '/ConditionableQuestion/In/Section/' + sectionId + '/For/Question/' + questionId;

                return $http
                    .get(reqUrl)
                    .then(function (response) { return response.data; })
            },

            // Get Conditionable Questions
            getConditionableQuestionsBySection: function (businessUnitId, questionnaireId, sectionId) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Questionnaire/' + questionnaireId + '/ConditionableQuestion/In/Section/' + sectionId;

                return $http
                    .get(reqUrl)
                    .then(function (response) { return response.data; })
            },

            // Get Conditionable Questions for a Section
            getConditionableQuestionsForSection: function (businessUnitId, questionnaireId, sectionId) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Questionnaire/' + questionnaireId + '/ConditionableQuestion/For/Section/' + sectionId;

                return $http
                    .get(reqUrl)
                    .then(function (response) { return response.data; })
            },

            // Create Question
            createQuestion: function (businessUnitId, questionnaireId, sectionId, question) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Questionnaire/' + questionnaireId + '/Section/' + sectionId + '/Question';

                return $http
                    .post(reqUrl, question)
                    .then(function (response) { return response.data; })
            },

            // Duplicate Question
            duplicateQuestion: function (businessUnitId, questionnaireId, sectionId, question, orderedIdList) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Questionnaire/' + questionnaireId + '/Section/' + sectionId + '/Question/' + question.ODDQuestionID;

                return $http
                    .post(reqUrl, { ODDQuestion: question, OrderedComponentIDs: orderedIdList })
                    .then(function (response) { return response.data; })
            },

            // Update Question
            updateQuestion: function (businessUnitId, questionnaireId, sectionId, question) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Questionnaire/' + questionnaireId + '/Section/' + sectionId + '/Question/' + question.ODDQuestionID;

                return $http
                    .put(reqUrl, question)
                    .then(function (response) { return response.data; })
            },

            // Delete Question
            deleteQuestion: function (businessUnitId, questionnaireId, sectionId, questionId) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Questionnaire/' + questionnaireId + '/Section/' + sectionId + '/Question/' + questionId;

                return $http
                    .delete(reqUrl)
                    .then(function (response) { return response.data; })
            },


            // ==== Components ====
            createPageBreak: function (businessUnitId, questionnaireId, sectionId) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Questionnaire/' + questionnaireId + '/Section/' + sectionId + '/PageBreak';

                return $http
                    .post(reqUrl)
                    .then(function (response) { return response.data; })
            },
            deletePageBreak: function (businessUnitId, questionnaireId, sectionId, pageBreakId) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Questionnaire/' + questionnaireId + '/Section/' + sectionId + '/PageBreak/' + pageBreakId;

                return $http
                    .delete(reqUrl)
                    .then(function (response) { return response.data; })
            },
            orderComponents: function (businessUnitId, questionnaireId, sectionId, components) {
                var reqUrl = baseUrl + '/' + businessUnitId + '/Questionnaire/' + questionnaireId + '/Section/' + sectionId + '/Component/Order';

                return $http
                    .put(reqUrl, components)
                    .then(function (response) { return response.data; })
            },

            // ==== Question Type ====

            // Get Question Types (cached)
            getQuestionTypes: function () {
                var reqUrl = oddUrl + '/QuestionType/Component/Question';

                return $http
                    .get(reqUrl, { cache: true })
                    .then(function (response) { return response.data; });
            },

            // Get Question Field Types (cached)
            getQuestionFieldTypes: function () {
                var reqUrl = oddUrl + '/QuestionType/Component/Field';

                return $http
                    .get(reqUrl, { cache: true })
                    .then(function (response) { return response.data; });
            },

            // Get Question Type (cached)
            getQuestionTypeByCode: function (questionTypeCode) {
                var reqUrl = oddUrl + '/QuestionType/' + questionTypeCode;

                return $http
                    .get(reqUrl, { cache: true })
                    .then(function (response) { return response.data; })
            },


            // ==== Question MultiChoice Templates ====

            // Get Question Types (cached)
            getQuestionMultiChoiceTemplates: function () {
                var reqUrl = oddUrl + '/QuestionChoiceTemplate';

                return $http
                    .get(reqUrl, { cache: true })
                    .then(function (response) { return response.data; })
            },

            // Get Question Type (cached)
            getQuestionMultiChoiceTemplate: function (questionMultiChoiceTemplateId) {
                var reqUrl = oddUrl + '/QuestionChoiceTemplate/' + questionMultiChoiceTemplateId;

                return $http
                    .get(reqUrl, { cache: true })
                    .then(function (response) { return response.data; })
            }

        };
    }]);
